import PropTypes from "prop-types";
import classNames from "classnames";
import { asIcon } from "../utils/library";

const Followed = ({ className, height = "31px", width = "31px" }) => {
    const classes = classNames("followedIcon", className);
    return (
        <svg
            width={width}
            height={height}
            className={classes}
            viewBox="0 0 31 31"
            version="1.1"
        >
            <g stroke="none" fillRule="evenodd">
                <g transform="translate(-307.000000, -920.000000)">
                    <g transform="translate(307.000000, 920.000000)">
                        <g>
                            <g>
                                <circle
                                    id="Oval"
                                    cx="15.5"
                                    cy="15.5"
                                    r="15.5"
                                ></circle>
                            </g>
                            <polyline
                                stroke="#FFFFFF"
                                strokeWidth="3.5"
                                points="9 15.5234375 15.013916 21.046875 22.7717285 10"
                            ></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

Followed.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

const IconFollowed = asIcon(Followed);
export { Followed, IconFollowed };
